// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ns-email[data-v-aebe2ecc]{position:relative}.theme--light.v-input:not(.v-input--is-disabled) input[data-v-aebe2ecc]{border:1px solid #252525}", ""]);
// Exports
module.exports = exports;
